import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  // 1. 主页
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home"),
  },

  // 2. 主分类详情页：显示该主分类下的子分类及其所有产品
  // 访问 /categories/main/1 => 展示主分类ID为1的内容
  {
    path: "/categories/main/:mainCategoryId",
    name: "MainCategory",
    component: () => import("@/views/Categories"),
    props: (route) => ({
      mode: "main",
      mainCategoryId: route.params.mainCategoryId,
    }),
  },

  // 3. 子分类详情页：显示该子分类下所有产品
  // 如访问 /categories/sub/5 => 展示子分类ID为5的内容
  {
    path: "/categories/sub/:subCategoryId",
    name: "SubCategory",
    component: () => import("@/views/Categories"),
    props: (route) => ({
      mode: "sub",
      subCategoryId: route.params.subCategoryId,
    }),
  },

  // 4. 产品详情页（产品 ID）
  {
    path: "/product/:id",
    name: "ProductDetail",
    component: () => import("@/views/Product"),
    props: true,
  },

  // 5. 联系我们
  {
    path: "/contact",
    name: "Contact",
    component: () => import("@/views/Contact"),
  },

  // 6. 关于我们
  {
    path: "/about",
    name: "About",
    component: () => import("@/views/About"),
  },

  // 7. 隐私政策等
  {
    path: "/policy",
    name: "Policy",
    component: () => import("@/views/Policy"),
  },
  // 8. terms of service
  {
    path: "/terms-of-service",
    name: "TermsOfService",
    component: () => import("@/views/Terms"),
  },

  // 404 页面（可选）
    // 404 页面
  {
    path: "*",
    name: "NotFound",
    component: () => import("@/views/NotFound"),
  },

];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { x: 0, y: 0 };
  },
});

// 捕获 NavigationDuplicated 错误并不再抛出
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  });
};

export default router;
